var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3234,
    height: 3234,
    viewBox: "0 0 3234 3234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_501_204",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 3234,
    height: 3234
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1617,
    cy: 1617,
    r: 1617,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_501_204)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -499,
    y: -703,
    width: 4281,
    height: 4281,
    fill: "#A1723A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_501_204)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1740.5,
    cy: 1441,
    rx: 1725.5,
    ry: 1725,
    fill: "#531002"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_501_204)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1926.5,
    cy: 1220,
    rx: 1399.5,
    ry: 1400,
    fill: "#2B5DF0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_501_204)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1901,
    cy: 1240.5,
    rx: 1459,
    ry: 1459.5,
    fill: "url(#paint0_radial_501_204)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_501_204)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2143,
    cy: 873,
    r: 735,
    fill: "#FCB8D4"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_501_204)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2142.5,
    cy: 872.5,
    r: 293.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_501_204)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1947.5,
    cy: 1165.5,
    r: 2637.5,
    fill: "url(#paint1_radial_501_204)",
    fillOpacity: 0.9
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_501_204",
    x: -385,
    y: -684,
    width: 4251,
    height: 4250,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_501_204",
    x: -273,
    y: -980,
    width: 4399,
    height: 4400,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 400,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_501_204",
    x: 142,
    y: -519,
    width: 3518,
    height: 3519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_501_204",
    x: 808,
    y: -462,
    width: 2670,
    height: 2670,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_501_204",
    x: 1449,
    y: 179,
    width: 1387,
    height: 1387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_501_204",
    x: -990,
    y: -1772,
    width: 5875,
    height: 5875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_501_204"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_501_204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2147.09 828.748) rotate(128.228) scale(2755.49 2755.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.286458,
    stopColor: "#387AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647782,
    stopColor: "#387AFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_501_204",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1947.5 1165.5) rotate(90) scale(2637.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZora);
export default __webpack_public_path__ + "static/media/zora.462d524cb237e6038e2d5759d2c2778f.svg";
export { ForwardRef as ReactComponent };